import { FeatureKey } from './types';

export function buildFailClosedFeatureStateMap(): Readonly<Record<FeatureKey, boolean>> {
  return Object.freeze(
    Object.fromEntries(Object.values(FeatureKey).map((key) => [key, false])) as Record<
      FeatureKey,
      boolean
    >,
  );
}
